
import { Component, ViewChild, ElementRef, AfterViewChecked, Input, Renderer2, EventEmitter, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { faCheckDouble, faCheck, faFile, faCircleArrowDown, faMicrophone, faMicrophoneSlash, faClose } from '@fortawesome/free-solid-svg-icons'
import { BasicDataForChatRequired, ChatAppMessageProperties } from '../Models/ChatAppProperties';
import { ChatAppService } from '../Services/chat-app.service';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';



@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css'],
  providers: [DatePipe]
})
export class ChatComponent implements AfterViewChecked {
  @ViewChild('chatWindow', { static: false }) chatWindow: ElementRef;
  userView: boolean = true;
  faCheckDouble = faCheckDouble;
  facheck = faCheck;
  @Input() GettingUniqueData: BasicDataForChatRequired;
  @Output() dataToParent = new EventEmitter<any>();
  faFile = faFile;
  faClose = faClose;
  faCircleArrowDown = faCircleArrowDown;
  newMessageFlag: boolean = false;
  newMessage: string = '';
  showImagePopup: boolean = false;
  popupImageUrl: string = '';
  sender: string = "User";
  messages: ChatAppMessageProperties[] = [];
  uniqueId: string = "";
  skeltonLoad: boolean = false;
  chatShow: boolean = false;
  previousMessageLength: number = this.messages.length;
  scrollAtBottom: boolean = true;
  recognition: any;
  faMicrophone = faMicrophone;
  faMicrophoneSlash = faMicrophoneSlash;
  isListening: boolean = false;
  menuVisible: boolean = false;
  spechtotextCommand: string = "Speak Now";
  isDragging = false;
  searchText = '';
  emojisTab: boolean = false;
  speechToTextTab: boolean = false;
  categories = [
    {
      name: '👍',
      emojis: [
        '👌', '🆗', '👍', '👎', '🤚', '🖐', '✋', '🖖', '👋', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️', '✊', '👊', '🤛',
        '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💅', '🤳', '💪', '🦾', '🦵', '🦿', '🦶',
        '👣', '👂', '🦻', '👃', '🧠', '🦷', '🦴', '👀', '👁', '👅', '👄', '💋'
      ]
    },
    {
      name: '😊',
      emojis: [
        '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '🥲', '🥹', '☺️', '😊', '😇', '🙂', '🙃', '😉',
        '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛', '😝', '😜', '🤪', '🤨', '🧐', '🤓', '😎',
        '🥸', '🤩', '🥳', '🙂‍↕️', '😏', '😒', '🙂‍↔️', '😞', '😔', '😟', '😕', '🙁', '☹️', '😣', '😖',
        '😫', '😩', '🥺', '😢', '😭', '😮‍💨', '😤', '😠', '😡', '🤬', '🤯', '😳', '🥵', '🥶', '😱', '😨',
        '😰', '😥', '😓', '🤗', '🫡', '🤔', '🤭', '🤫', '🤥', '😶', '😶‍🌫️', '😐', '😑', '😬', '🙄', '😯', '😦', '😧', '😮', '😲', '🥱', '😴', '🤤', '😪', '😵', '😵‍💫', '🫥', '🤐',
        '🥴', '🤢', '🤮', '🤧', '😷', '🤒', '🤕', '🤑', '🤠', '😈', '👿', '👹', '👺', '🤡', '💩', '👻',
        '💀', '☠️', '👽', '👾', '🤖', '🎃', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿'
      ]
    },
    {
      name: '✈️',
      emojis: ["🚕", "🚙", "🚌", "🚎", "🏎", "🚓", "🚑", "🚒", "🚐", "🛻", "🚚", "🚛", "🚜", "🦯", "🦽", "🦼", "🛴", "🚲", "🛵", "🏍", "🛺", "🚨", "🚔", "🚍", "🚘", "🚖", "🛞", "🚡", "🚠", "🚟", "🚃", "🚋", "🚞", "🚝", "🚄", "🚅", "🚈", "🚂", "🚆", "🚇", "🚊", "🚉", "✈️", "🛫", "🛬", "🛩", "💺", "🛰", "🚀", "🛸", "🚁", "🛶", "⛵️", "🚤", "🛥", "🛳", "⛴", "🚢", "⚓️", "🛟", "🪝", "⛽️", "🚧", "🚦", "🚥", "🚏", "🗺", "🗿", "🗽", "🗼", "🏰", "🏯", "🏟", "🎡", "🎢", "🛝", "🎠", "⛲️", "⛱", "🏖", "🏝", "🏜", "🌋", "⛰", "🏔", "🗻", "🏕", "⛺️", "🛖", "🏠", "🏡", "🏘", "🏚", "🏗", "🏭", "🏢", "🏬", "🏣", "🏤", "🏥", "🏦", "🏨", "🏪", "🏫", "🏩", "💒", "🏛", "⛪️", "🕌", "🕍", "🛕", "🕋", "⛩", "🛤", "🛣", "🗾", "🎑", "🏞", "🌅", "🌄", "🌠", "🎇", "🎆", "🌇", "🌆", "🏙", "🌃", "🌌", "🌉", "🌁"]

    },
    {
      name: '🧳',
      emojis: ["🧳", "🌂", "☂️", "🧵", "🧶", "👓", "🕶", "🥽", "🥼", "🦺", "👔", "👕", "👖", "🧣", "🧤", "🧥", "🧦", "👗", "👘", "🥻", "👙", "👚", "👛", "👜", "👝", "🎒", "👞", "👟", "🥾", "🥿", "👠", "👡", "👢", "👑", "👒", "🎩", "🎓", "🧢", "⛑", "💄", "💍"]

    },
    {
      name: '❤️',
      emojis: ["❤️", "🩷", "🧡", "💛", "💚", "💙", "🩵", "💜", "🖤", "🩶", "🤍", "🤎", "❤️‍🔥", "❤️‍🩹", "💔", "❣️", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "☢️", "☣️", "📴", "📳", "🈶", "🈚️", "🈸", "🈺", "🈷️", "✴️", "🆚", "💮", "🉐", "㊙️", "㊗️",
        "🈴", "🈵", "🈹", "🈲", "🅰️", "🅱️", "🆎", "🆑", "🅾️", "🆘", "❌", "⭕️", "🛑", "⛔️", "📛", "🚫",
        "💯", "💢", "♨️", "🚷", "🚯", "🚳", "🚱", "🔞", "📵", "🚭", "❗️", "❕", "❓", "❔", "‼️", "⁉️", "🔅",
        "🔆", "〽️", "⚠️", "🚸", "🔱", "⚜️", "🔰", "♻️", "✅", "🈯️", "💹", "❇️", "✳️", "❎", "🌐", "💠", "Ⓜ️",
        "🌀", "💤", "🏧", "🚾", "♿️", "🅿️", "🛗", "🈳", "🈂️", "🛂", "🛃", "🛄", "🛅", "🚹", "🚺", "🚼", "⚧",
        "🚻", "🚮", "🎦", "🛜", "📶", "🈁", "🔣", "ℹ️", "🔤", "🔡", "🔠", "🆖", "🆗", "🆙", "🆒", "🆕", "🆓",
        "0️⃣", "1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣", "7️⃣", "8️⃣", "9️⃣", "🔟", "🔢", "#️⃣", "*️⃣", "⏏️",
        "▶️", "⏸", "⏯", "⏹", "⏺", "⏭", "⏮", "⏩", "⏪", "⏫", "⏬", "◀️", "🔼", "🔽", "➡️", "⬅️", "⬆️",
        "⬇️", "↗️", "↘️", "↙️", "↖️", "↕️", "↔️", "↪️", "↩️", "⤴️", "⤵️", "🔀", "🔁", "🔂", "🔄", "🔃", "🎵",
        "🎶", "➕", "➖", "➗", "✖️", "🟰", "♾", "💲", "💱", "™️", "©️", "®️", "〰️", "➰", "➿", "🔚", "🔙", "🔛",
        "🔝", "🔜", "✔️", "☑️", "🔘", "🔴", "🟠", "🟡", "🟢", "🔵", "🟣", "⚫️", "⚪️", "🟤", "🔺", "🔻", "🔸",
        "🔹", "🔶", "🔷", "🔳", "🔲", "▪️", "▫️", "◾️", "◽️", "◼️", "◻️", "🟥", "🟧", "🟨", "🟩", "🟦", "🟪",
        "⬛️", "⬜️", "🟫", "🔈", "🔇", "🔉", "🔊", "🔔", "🔕", "📣", "📢", "👁‍🗨", "💬", "💭", "🗯", "♠️", "♣️",
        "♥️", "♦️", "🃏", "🎴", "🀄️", "🕐", "🕑", "🕒", "🕓", "🕔", "🕕", "🕖", "🕗", "🕘", "🕙", "🕚", "🕛",
        "🕜", "🕝", "🕞", "🕟", "🕠", "🕡", "🕢", "🕣", "🕤", "🕥", "🕦"]

    },


    {
      name: '👧',
      emojis: [
        "👧", "🧒", "👦", "👩", "🧑", "👨", "👩‍🦱", "🧑‍🦱", "👨‍🦱", "👩‍🦰", "🧑‍🦰", "👨‍🦰",
        "👱‍♀️", "👱", "👱‍♂️", "👩‍🦳", "🧑‍🦳", "👨‍🦳", "👩‍🦲", "🧑‍🦲", "👨‍🦲", "🧔‍♀️", "🧔",
        "🧔‍♂️", "👵", "🧓", "👴", "👲", "👳‍♀️", "👳", "👳‍♂️", "🧕", "👮‍♀️", "👮", "👮‍♂️", "👷‍♀️",
        "👷", "👷‍♂️", "💂‍♀️", "💂", "💂‍♂️", "🕵️‍♀️", "🕵️", "🕵️‍♂️", "👩‍⚕️", "🧑‍⚕️", "👨‍⚕️",
        "👩‍🌾", "🧑‍🌾", "👨‍🌾", "👩‍🍳", "🧑‍🍳", "👨‍🍳", "👩‍🎓", "🧑‍🎓", "👨‍🎓", "👩‍🎤", "🧑‍🎤",
        "👨‍🎤", "👩‍🏫", "🧑‍🏫", "👨‍🏫", "👩‍🏭", "🧑‍🏭", "👨‍🏭", "👩‍💻", "🧑‍💻", "👨‍💻", "👩‍💼",
        "🧑‍💼", "👨‍💼", "👩‍🔧", "🧑‍🔧", "👨‍🔧", "👩‍🔬", "🧑‍🔬", "👨‍🔬", "👩‍🎨", "🧑‍🎨", "👨‍🎨",
        "👩‍🚒", "🧑‍🚒", "👨‍🚒", "👩‍✈️", "🧑‍✈️", "👨‍✈️", "👩‍🚀", "🧑‍🚀", "👨‍🚀", "👩‍⚖️", "🧑‍⚖️",
        "👨‍⚖️", "👰‍♀️", "👰", "👰‍♂️", "🤵‍♀️", "🤵", "🤵‍♂️", "👸", "🫅", "🤴", "🥷", "🦸‍♀️", "🦸",
        "🦸‍♂️", "🦹‍♀️", "🦹", "🦹‍♂️", "🤶", "🧑‍🎄", "🎅", "🧙‍♀️", "🧙", "🧙‍♂️", "🧝‍♀️", "🧝",
        "🧝‍♂️", "🧛‍♀️", "🧛", "🧛‍♂️", "🧟‍♀️", "🧟", "🧟‍♂️", "🧞‍♀️", "🧞", "🧞‍♂️", "🧜‍♀️",
        "🧜", "🧜‍♂️", "🧚‍♀️", "🧚", "🧚‍♂️", "🧌", "👼", "🤰", "🫄", "🫃", "🤱", "👩‍🍼", "🧑‍🍼",
        "👨‍🍼", "🙇‍♀️", "🙇", "🙇‍♂️", "💁‍♀️", "💁", "💁‍♂️", "🙅‍♀️", "🙅", "🙅‍♂️", "🙆‍♀️",
        "🙆", "🙆‍♂️", "🙋‍♀️", "🙋", "🙋‍♂️", "🧏‍♀️", "🧏", "🧏‍♂️", "🤦‍♀️", "🤦", "🤦‍♂️", "🤷‍♀️",
        "🤷", "🤷‍♂️", "🙎‍♀️", "🙎", "🙎‍♂️", "🙍‍♀️", "🙍", "🙍‍♂️", "💇‍♀️", "💇", "💇‍♂️", "💆‍♀️",
        "💆", "💆‍♂️", "🧖‍♀️", "🧖", "🧖‍♂️", "💅", "🤳", "💃", "🕺", "👯‍♀️", "👯", "👯‍♂️", "🕴",
        "👩‍🦽", "👩‍🦽‍➡️", "🧑‍🦽", "🧑‍🦽‍➡️", "👨‍🦽", "👨‍🦽‍➡️", "👩‍🦼", "👩‍🦼‍➡️", "🧑‍🦼",
        "🧑‍🦼‍➡️", "👨‍🦼", "👨‍🦼‍➡️", "🚶‍♀️", "🚶‍♀️‍➡️", "🚶", "🚶‍➡️", "🚶‍♂️", "🚶‍♂️‍➡️",
        "👩‍🦯", "👩‍🦯‍➡️", "🧑‍🦯", "🧑‍🦯‍➡️", "👨‍🦯", "👨‍🦯‍➡️", "🧎‍♀️", "🧎‍♀️‍➡️", "🧎",
        "🧎‍➡️", "🧎‍♂️", "🧎‍♂️‍➡️", "🏃‍♀️", "🏃‍♀️‍➡️", "🏃", "🏃‍➡️", "🏃‍♂️", "🏃‍♂️‍➡️",
        "🧍‍♀️", "🧍", "🧍‍♂️", "👭", "🧑‍🤝‍🧑", "👬", "👫", "👩‍❤️‍👩", "💑", "👨‍❤️‍👨", "👩‍❤️‍👨",
        "👩‍❤️‍💋‍👩", "💏", "👨‍❤️‍💋‍👨", "👩‍❤️‍💋‍👨", "👪", "👨‍👩‍👦", "👨‍👩‍👧", "👨‍👩‍👧‍👦",
        "👨‍👩‍👦‍👦", "👨‍👩‍👧‍👧", "👨‍👨‍👦", "👨‍👨‍👧", "👨‍👨‍👧‍👦", "👨‍👨‍👦‍👦", "👨‍👨‍👧‍👧",
        "👩‍👩‍👦", "👩‍👩‍👧", "👩‍👩‍👧‍👦", "👩‍👩‍👦‍👦", "👩‍👩‍👧‍👧", "👨‍👦", "👨‍👦‍👦", "👨‍👧",
        "👨‍👧‍👦", "👨‍👧‍👧", "👩‍👦", "👩‍👦‍👦", "👩‍👧", "👩‍👧‍👦", "👩‍👧‍👧", "🧑‍🧑‍🧒",
        "🧑‍🧑‍🧒‍🧒", "🧑‍🧒", "🧑‍🧒‍🧒", "🗣", "👤", "👥"
      ]

    },


    {
      name: '🍎',
      emojis: ["🍏", "🍎", "🍐", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🍈", "🍒", "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🍆", "🥑", "🥦", "🫛", "🥬", "🥒", "🌶", "🫑", "🌽", "🥕", "🫒", "🧄", "🧅", "🥔", "🍠", "🥐", "🥯", "🍞", "🥖", "🥨", "🧀", "🥚", "🍳", "🧈", "🥞", "🧇", "🥓", "🥩", "🍗", "🍖", "🦴", "🌭", "🍔", "🍟", "🍕", "🥪", "🥙", "🧆", "🌮", "🌯", "🥗", "🥘", "🥫", "🍝", "🍜", "🍲", "🍛", "🍣", "🍱", "🥟", "🦪", "🍤", "🍙", "🍚", "🍘", "🍥", "🥠", "🥮", "🍢", "🍡", "🍧", "🍨", "🍦", "🥧", "🧁", "🍰", "🎂", "🍮", "🍭", "🍬", "🍫", "🍿", "🍩", "🍪", "🌰", "🥜", "🍯", "🥛", "🍼", "🫖", "☕️", "🍵", "🧃", "🥤", "🧋", "🫙", "🍶", "🍺", "🍻", "🥂", "🍷", "🫗", "🥃", "🍸", "🍹", "🧉", "🍾", "🧊", "🥄", "🍴", "🍽", "🥣", "🥡", "🥢", "🧂"]

    },
    {
      name: '🏀',
      emojis: ["🏀", "🏈", "⚾️", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱", "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳️", "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷", "⛸", "🥌", "🎿", "⛷", "🏂", "🪂", "🏋️‍♀️", "🏋️", "🏋️‍♂️", "🤼‍♀️", "🤼", "🤼‍♂️", "🤸‍♀️", "🤸", "🤸‍♂️", "⛹️‍♀️", "⛹️", "⛹️‍♂️", "🤺", "🤾‍♀️", "🤾", "🤾‍♂️", "🏌️‍♀️", "🏌️", "🏌️‍♂️", "🏇", "🧘‍♀️", "🧘", "🧘‍♂️", "🏄‍♀️", "🏄", "🏄‍♂️", "🏊‍♀️", "🏊", "🏊‍♂️", "🤽‍♀️", "🤽", "🤽‍♂️", "🚣‍♀️", "🚣", "🚣‍♂️", "🧗‍♀️", "🧗", "🧗‍♂️", "🚵‍♀️", "🚵", "🚵‍♂️", "🚴‍♀️", "🚴", "🚴‍♂️", "🏆", "🥇", "🥈", "🥉", "🏅", "🎖", "🏵", "🎗", "🎫", "🎟", "🎪", "🤹", "🤹‍♂️", "🤹‍♀️", "🎭", "🩰", "🎨", "🎬", "🎤", "🎧", "🎼", "🎹", "🥁", "🪘", "🪇", "🎷", "🎺", "🪗", "🎸", "🪕", "🎻", "🪈", "🎲", "♟", "🎯", "🎳", "🎮", "🎰", "🧩"]

    }
  ];
  constructor(private messageService: MessageService, private router: Router, private renderer: Renderer2, private el: ElementRef, private http: HttpClient, private datePipe: DatePipe, private chatservice: ChatAppService) {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;
      this.recognition.onresult = (event: any) => {
        const speechResult = event.results[0][0].transcript;
        this.newMessage += " " + speechResult;
        this.isListening = false;
        this.speechToTextTab = false;
      };
      this.recognition.onerror = (event: any) => {
        this.isListening = false;
        this.speechToTextTab = false;
      };
    } else {
      this.isListening = false;
      this.speechToTextTab = false;
      this.messageService.add({ severity: 'error', summary: 'Change Browser', detail: "Voice is not supported in this browser" });
    }
  }
  private messagesSubscription: Subscription | null = null;
  ngOnInit() {
    this.skeltonLoad = true;
    this.GetMessagesList(true);
    this.messagesSubscription = interval(5000).subscribe(() => {
      this.GetMessagesList(false);
    });
  }
  ngOnDestroy() {
    if (this.messagesSubscription) {
      this.messagesSubscription.unsubscribe();

    }
  }
  ngAfterViewChecked() {
    this.CheckScrollPosition();
  }
  public GetMessagesList = (firsttime): void => {
    if (this.GettingUniqueData.property1 != undefined && this.GettingUniqueData.property1 != "") {
      this.uniqueId = this.GettingUniqueData.property1;
      this.sender = this.GettingUniqueData.property2;
      this.chatservice.GetMessagesByUniqueIdWithAdapter(this.uniqueId, this.sender).subscribe((data) => {
        if (data) {
          //if (JSON.stringify(this.messages) !== JSON.stringify(data)) {
          if (this.previousMessageLength != data.length) {
            this.messages = data;
            this.ScrollToLatestMessage();
            this.dataToParent.emit(this.messages);
            if (this.messages.length > 0) {
              this.FilterMessages();
              if (firsttime) {
                setTimeout(() => {

                  this.skeltonLoad = false;
                  this.chatShow = true;
                  setTimeout(() => {
                    this.ScrollToLatestMessage();
                  }, 1000);
                }, 2000);

              }

            }
          }
          else {
            this.messages.forEach(msg => {
              const matchingData = data.find(d => d.messageId === msg.messageId);
              if (matchingData) {
                msg.seen = matchingData.seen; 
              }
            });
            this.skeltonLoad = false;
            this.chatShow = true;
          }
        }
        else {

          this.skeltonLoad = false;
          this.chatShow = true;
        }
      });

    }
    else {
      setTimeout(() => {
        this.skeltonLoad = false;
        this.chatShow = true;
      }, 4000);
    }
  }
  private CheckScrollPosition() {
    const chatWindow = this.chatWindow.nativeElement;
    this.scrollAtBottom = chatWindow.scrollHeight - chatWindow.scrollTop === chatWindow.clientHeight;
  }
  private DateGet = (): string => {
    const date = new Date();
    const formattedDate = date.toISOString().split('T')[0];
    console.log(formattedDate);
    return formattedDate;

  }
  public SendMessage = (): void => {
    if (this.newMessage.trim()) {
      this.emojisTab = false;
      let messageobj = new ChatAppMessageProperties();
      messageobj = this.RequiredEveryMessageData();
      messageobj.content = this.newMessage;
      const formData = new FormData();
      formData.append('messageChat', JSON.stringify(messageobj));
      this.SendBackData(formData);
    }
  }
  private ScrollToLatestMessage = (): void => {
    this.newMessageFlag = false;
    this.ScrollToBottom();
  }
  private ScrollToBottom = (): void => {
    const chatWindow = this.chatWindow.nativeElement;
    chatWindow.scrollTop = chatWindow.scrollHeight;
  }
  private FilterMessages = (): void => {
    this.previousMessageLength = this.messages.length;
    let lastDate: string | null = null;
    this.messages = this.messages.reduce((accumulator, msg) => {
      const isNewDate = msg.date !== lastDate;

      if (isNewDate) {
        accumulator.push({
          date: this.GetFormattedDate(msg.date),
          dateChanged: true
        });
      } else {
        //accumulator.push({ dateChanged: false });
      }

      accumulator.push({
        sender: msg.sender,
        dateChanged: msg.dateChanged,
        fileUrl: msg.fileUrl,
        isImage: msg.isImage,
        isFile: msg.isFile,
        messageId: msg.messageId,
        seen: msg.seen,
        uniqueId: msg.uniqueId,
        content: msg.content,
        senderName: msg.senderName,
        timestamp: msg.timestamp,
        userId: msg.userId,
        date: msg.date
      });

      lastDate = msg.date;
      return accumulator;
    }, []);
  }
  public OpenImage = (imageUrl: string): void => {
    this.popupImageUrl = imageUrl;
    this.showImagePopup = true;
  }
  public CloseImage = (): void => {
    this.showImagePopup = false;
    this.popupImageUrl = '';
  }
  private GetFormattedDate=(datenot): string =>{
    const date = new Date(datenot);
    const currentDate = new Date();
    const inputDate = new Date(date);
    const yesterday = new Date();
    yesterday.setDate(currentDate.getDate() - 1);
    const isToday = inputDate.getDate() === currentDate.getDate() &&
      inputDate.getMonth() === currentDate.getMonth() &&
      inputDate.getFullYear() === currentDate.getFullYear();

    const isYesterday = inputDate.getDate() === yesterday.getDate() &&
      inputDate.getMonth() === yesterday.getMonth() &&
      inputDate.getFullYear() === yesterday.getFullYear();

    const dayOfWeek = inputDate.getDay();
    const weekdayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const formattedDate = this.datePipe.transform(inputDate, 'MM/dd/yyyy');

    if (isToday) {
      return `Today ${formattedDate}`;
    } else if (isYesterday) {
      return `Yesterday ${formattedDate}`;
    } else {
      return `${weekdayNames[dayOfWeek]} ${formattedDate}`;
    }
  }
  public ToggleMenu = (): void =>{
    this.menuVisible = !this.menuVisible;
    this.emojisTab = false;
  }
  public OnAttach = (option: string): void => {
    switch (option) {
      case 'document':
        console.log('Attach Document');
        this.AttachFile('application/*');
        break;
      case 'photos':
        console.log('Attach Photos/Videos');
        this.AttachFile('image/*, video/*');
        break;
    }
    this.menuVisible = false;
  }
  private AttachFile = (acceptType: string): void => {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = acceptType;
    fileInput.multiple = true;

    fileInput.onchange = (event: any) => {
      const files = event.target.files;
      if (files) {
        this.HandleFileUpload(files);

      }
    };

    fileInput.click();
  }
  public OnDragOver = (event: DragEvent): void =>{
    event.preventDefault();
    this.isDragging = true;
  }
  public OnDragLeave = (event: DragEvent): void => {
    event.preventDefault();
    this.isDragging = false;
  }
  public OnDrop = (event: DragEvent): void => {
    event.preventDefault();
    this.isDragging = false;
    let checkfilelen = event.dataTransfer.files.length;
    if (checkfilelen > 0) {
      const files = event.dataTransfer.files;
      console.log('Files dropped:', files);
      this.HandleFileUpload(files);
    }
  }
  private HandleFileUpload = (files: FileList): void => {
    let messageobj = new ChatAppMessageProperties();
    messageobj = this.RequiredEveryMessageData();
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      const isImage = files[i].type.startsWith('image');
      messageobj.isImage = isImage;
      messageobj.isFile = !isImage;
      messageobj.files.push(files[i]);
      formData.append("file", files[i]);
    }
    formData.append('messageChat', JSON.stringify(messageobj));
    this.SendBackData(formData);
  }
  private RequiredEveryMessageData=(): ChatAppMessageProperties =>{
    let messageobj = new ChatAppMessageProperties();
    messageobj.sender = this.GettingUniqueData.property2;
    messageobj.content = "";
    messageobj.seen = false;
    messageobj.date = this.DateGet();
    messageobj.uniqueId = this.GettingUniqueData.property1;
    messageobj.senderName = localStorage.getItem("fullName");
    messageobj.userId = Number(localStorage.getItem("UserId"));
    messageobj.timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return messageobj;
  }
  private SendBackData=(formData: FormData): void => {

    this.chatservice.SaveMessage(formData).subscribe((data) => {
      if (data.success) {
        this.GetMessagesList(false);
        this.newMessage = '';
        this.ScrollToLatestMessage();
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: data.message });
      }
    });

  }
  public DownloadImage=(url: string, msgindex: number, fileindex: number): void => {
    const button = this.el.nativeElement.querySelector(`#btn-circle-download${msgindex}${fileindex}`);
    this.renderer.addClass(button, 'load');

    setTimeout(() => {
      this.renderer.removeClass(button, 'load');
      this.renderer.removeClass(button, 'done');
    }, 5000);

    const fileExtension = url.split('.').pop().toLowerCase();
    let fileName = 'file';

    if (fileExtension === 'pdf') {
      fileName = 'document.pdf';
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
      fileName = `image.${fileExtension}`;
    } else {
      fileName = `file.${fileExtension}`;
    }

    this.http.get(url, { responseType: 'blob' }).subscribe((blob) => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
      this.renderer.addClass(button, 'done');
    });
  }
  public OnPaste=(event: ClipboardEvent): void =>{
    const clipboardItems = event.clipboardData.items;
    if (!clipboardItems) return;
    const filesArray: File[] = [];
    for (let i = 0; i < clipboardItems.length; i++) {
      const item = clipboardItems[i];
      if (item.kind === 'file') {
        const file = item.getAsFile();
        if (file) {
          filesArray.push(file);
        }
      }
    }

    if (filesArray.length > 0) {
      const dataTransfer = new DataTransfer();
      filesArray.forEach(file => dataTransfer.items.add(file));
      this.HandleFileUpload(dataTransfer.files);
    }
  }
  public FilterEmojis=(emojis: string[]): string[] =>{
    return emojis.filter((emoji) =>
      emoji.includes(this.searchText.trim())
    );
  }
  public ToggleEmojisTabMenu=(): void =>{
    this.emojisTab = !this.emojisTab;
    this.menuVisible = false;
    this.speechToTextTab = false;
  }
  public ToggleVoiceToTextTab = (): void => {
    this.speechToTextTab = !this.speechToTextTab;
    this.menuVisible = false;
    this.emojisTab = false;
    if (this.speechToTextTab) {
      this.StartListening();
    }

  }
  public OnEmojiClick=(emoji: string): void => {
    this.newMessage += emoji;
  }
  public StartListening = (): void =>{
    this.spechtotextCommand = "Speak Now";
    if (this.recognition) {
      this.recognition.start();
    }
    this.isListening = true;
    setTimeout(() => {
      this.spechtotextCommand = "Listening....";
    }, 3000);



  }
  popupcloselisten() {
    this.isListening = false;
    this.speechToTextTab = false;
  }

}
